/**
 * API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { AssignLeadCommand } from '../model/assignLeadCommand';
import { AssignLeadCommandResult } from '../model/assignLeadCommandResult';
import { CaptureLeadIntentCommand } from '../model/captureLeadIntentCommand';
import { CaptureLeadIntentCommandResult } from '../model/captureLeadIntentCommandResult';
import { GetLeadsQueryResult } from '../model/getLeadsQueryResult';
import { InlineResponse404 } from '../model/inlineResponse404';
import { IntentType } from '../model/intentType';
import { LeadModel } from '../model/leadModel';
import { LeadStatusType } from '../model/leadStatusType';
import { MarkLeadAsContactedCommand } from '../model/markLeadAsContactedCommand';
import { MarkLeadAsContactedCommandResult } from '../model/markLeadAsContactedCommandResult';
import { MarkLeadAsDeadCommand } from '../model/markLeadAsDeadCommand';
import { MarkLeadAsDeadCommandResult } from '../model/markLeadAsDeadCommandResult';
import { SetLeadNoteCommand } from '../model/setLeadNoteCommand';
import { SetLeadNoteCommandResult } from '../model/setLeadNoteCommandResult';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class LeadsService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public leadsAssignPost(body?: AssignLeadCommand, observe?: 'body', reportProgress?: boolean): Observable<AssignLeadCommandResult>;
    public leadsAssignPost(body?: AssignLeadCommand, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<AssignLeadCommandResult>>;
    public leadsAssignPost(body?: AssignLeadCommand, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<AssignLeadCommandResult>>;
    public leadsAssignPost(body?: AssignLeadCommand, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<AssignLeadCommandResult>('post',`${this.basePath}/Leads/Assign`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public leadsContactedPost(body?: MarkLeadAsContactedCommand, observe?: 'body', reportProgress?: boolean): Observable<MarkLeadAsContactedCommandResult>;
    public leadsContactedPost(body?: MarkLeadAsContactedCommand, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MarkLeadAsContactedCommandResult>>;
    public leadsContactedPost(body?: MarkLeadAsContactedCommand, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MarkLeadAsContactedCommandResult>>;
    public leadsContactedPost(body?: MarkLeadAsContactedCommand, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<MarkLeadAsContactedCommandResult>('post',`${this.basePath}/Leads/Contacted`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public leadsDeadPost(body?: MarkLeadAsDeadCommand, observe?: 'body', reportProgress?: boolean): Observable<MarkLeadAsDeadCommandResult>;
    public leadsDeadPost(body?: MarkLeadAsDeadCommand, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MarkLeadAsDeadCommandResult>>;
    public leadsDeadPost(body?: MarkLeadAsDeadCommand, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MarkLeadAsDeadCommandResult>>;
    public leadsDeadPost(body?: MarkLeadAsDeadCommand, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<MarkLeadAsDeadCommandResult>('post',`${this.basePath}/Leads/Dead`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param filterName 
     * @param filterEmail 
     * @param filterPhoneNumber 
     * @param filterSSN 
     * @param filterIntent 
     * @param filterStatus 
     * @param filterBrokerUid 
     * @param pageNumber 
     * @param pageSize 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public leadsGet(filterName?: string, filterEmail?: string, filterPhoneNumber?: string, filterSSN?: string, filterIntent?: IntentType, filterStatus?: LeadStatusType, filterBrokerUid?: string, pageNumber?: number, pageSize?: number, observe?: 'body', reportProgress?: boolean): Observable<GetLeadsQueryResult>;
    public leadsGet(filterName?: string, filterEmail?: string, filterPhoneNumber?: string, filterSSN?: string, filterIntent?: IntentType, filterStatus?: LeadStatusType, filterBrokerUid?: string, pageNumber?: number, pageSize?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetLeadsQueryResult>>;
    public leadsGet(filterName?: string, filterEmail?: string, filterPhoneNumber?: string, filterSSN?: string, filterIntent?: IntentType, filterStatus?: LeadStatusType, filterBrokerUid?: string, pageNumber?: number, pageSize?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetLeadsQueryResult>>;
    public leadsGet(filterName?: string, filterEmail?: string, filterPhoneNumber?: string, filterSSN?: string, filterIntent?: IntentType, filterStatus?: LeadStatusType, filterBrokerUid?: string, pageNumber?: number, pageSize?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {










        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (filterName !== undefined && filterName !== null) {
            queryParameters = queryParameters.set('Filter.Name', <any>filterName);
        }
        if (filterEmail !== undefined && filterEmail !== null) {
            queryParameters = queryParameters.set('Filter.Email', <any>filterEmail);
        }
        if (filterPhoneNumber !== undefined && filterPhoneNumber !== null) {
            queryParameters = queryParameters.set('Filter.PhoneNumber', <any>filterPhoneNumber);
        }
        if (filterSSN !== undefined && filterSSN !== null) {
            queryParameters = queryParameters.set('Filter.SSN', <any>filterSSN);
        }
        if (filterIntent !== undefined && filterIntent !== null) {
            queryParameters = queryParameters.set('Filter.Intent', <any>filterIntent);
        }
        if (filterStatus !== undefined && filterStatus !== null) {
            queryParameters = queryParameters.set('Filter.Status', <any>filterStatus);
        }
        if (filterBrokerUid !== undefined && filterBrokerUid !== null) {
            queryParameters = queryParameters.set('Filter.BrokerUid', <any>filterBrokerUid);
        }
        if (pageNumber !== undefined && pageNumber !== null) {
            queryParameters = queryParameters.set('PageNumber', <any>pageNumber);
        }
        if (pageSize !== undefined && pageSize !== null) {
            queryParameters = queryParameters.set('PageSize', <any>pageSize);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<GetLeadsQueryResult>('get',`${this.basePath}/Leads`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public leadsIntentPost(body?: CaptureLeadIntentCommand, observe?: 'body', reportProgress?: boolean): Observable<CaptureLeadIntentCommandResult>;
    public leadsIntentPost(body?: CaptureLeadIntentCommand, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CaptureLeadIntentCommandResult>>;
    public leadsIntentPost(body?: CaptureLeadIntentCommand, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CaptureLeadIntentCommandResult>>;
    public leadsIntentPost(body?: CaptureLeadIntentCommand, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<CaptureLeadIntentCommandResult>('post',`${this.basePath}/Leads/Intent`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public leadsMineGet(observe?: 'body', reportProgress?: boolean): Observable<LeadModel>;
    public leadsMineGet(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<LeadModel>>;
    public leadsMineGet(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<LeadModel>>;
    public leadsMineGet(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<LeadModel>('get',`${this.basePath}/Leads/Mine`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public leadsNotePost(body?: SetLeadNoteCommand, observe?: 'body', reportProgress?: boolean): Observable<SetLeadNoteCommandResult>;
    public leadsNotePost(body?: SetLeadNoteCommand, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SetLeadNoteCommandResult>>;
    public leadsNotePost(body?: SetLeadNoteCommand, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SetLeadNoteCommandResult>>;
    public leadsNotePost(body?: SetLeadNoteCommand, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<SetLeadNoteCommandResult>('post',`${this.basePath}/Leads/Note`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param uid 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public leadsUidGet(uid: string, observe?: 'body', reportProgress?: boolean): Observable<LeadModel>;
    public leadsUidGet(uid: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<LeadModel>>;
    public leadsUidGet(uid: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<LeadModel>>;
    public leadsUidGet(uid: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (uid === null || uid === undefined) {
            throw new Error('Required parameter uid was null or undefined when calling leadsUidGet.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<LeadModel>('get',`${this.basePath}/Leads/${encodeURIComponent(String(uid))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
